import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { CheckinReceipt } from './checkin-receipt'
import { SelfCheckinCompleteState } from '@/components/pages/self-checkin/complete'
import { SelfCheckinHotelInfo } from '../hotel-info'
import {
  completeWithPrinterBackgroundStyle,
  completeWithPrinterCardStyle,
  completeWithPrinterFrontLayoutStyle,
  completeWithPrinterRoomLayoutStyle,
} from './complete-with-printer-styles'
import { ButtonType } from '@/components/atoms/button'
import { CompletionButton } from '@/components/molecules/self-checkin/completion-button'

type Props = {
  onClickTop: () => void
  onPrint: () => void
  state: SelfCheckinCompleteState
  basicInfo: {
    hotelNameLatin: string
    telephone: string
    frontOpenTime: string
    frontCloseTime: string
  }
  completeReceiptHandled: boolean
}
export const FrontSupportWithPrinter: React.FC<Props> = ({ onClickTop, state, ...props }) => {
  const { t } = useTranslation()
  const [isCompletedPrint, setIsCompletedPrint] = useState(props.completeReceiptHandled || false)

  return (
    <div css={completeWithPrinterBackgroundStyle}>
      <div
        css={[completeWithPrinterCardStyle, completeWithPrinterRoomLayoutStyle, completeWithPrinterFrontLayoutStyle]}
        className="front-print"
      >
        <div className="head-line-block">
          <img src={require('@/static/images/icon_checkin_orange.svg')}></img>
          <span>{t('Check-in completed')}</span>
        </div>
        <div className="announce-block">
          <div className="checkin-message-block">
            <div className="front-support-message">
              {t('SelfCheckIn.Printed accommodation guide.')}
              <br />
              <Trans i18nKey="SelfCheckIn.Please take this at hand and hand it to the front desk.">
                Please take this at hand and hand it<span style={{ color: '#F2A40B' }}>to the front desk.</span>
              </Trans>
            </div>
            <CompletionButton
              buttonType={isCompletedPrint ? ButtonType.Primary : ButtonType.PrimaryDisabled}
              onClick={onClickTop}
              isDisabled={!isCompletedPrint}
            >
              {t('SelfCheckIn.Confirmed')}
            </CompletionButton>
          </div>
          <div className="printer-demo-block">
            <img src={require('@/static/images/self-checkin/checkin-printer-a.png')} />
            <img src={require('@/static/images/self-checkin/checkin-printer-b.png')} />
          </div>
        </div>
        {!isCompletedPrint && (
          <CheckinReceipt
            state={state}
            onComplete={() => {
              setIsCompletedPrint(true)
              props.onPrint()
            }}
          />
        )}
      </div>
      <SelfCheckinHotelInfo
        telephone={props.basicInfo.telephone}
        frontOpenTime={props.basicInfo.frontOpenTime}
        frontCloseTime={props.basicInfo.frontCloseTime}
        position="static"
        usedIn="roomGuidance"
      />
    </div>
  )
}
